export const BadgeStyles = {
  SHARED: 'min-w-[60px] h-[22px] border-[1px] rounded-sm flex justify-evenly items-center px-[4px] gap-[5px]',
  SHARED_TEXT: 'font-metricR text-[13px] ',
  PENDING: 'text-badgeAmber02 bg-badgeAmber00 border-badgeAmber00',
  PAID: 'text-badgeGreen02 bg-badgeGreen00 border-badgeGreen00',
  AWAITING_DETAILS: 'text-badgeBlue02 bg-badgeBlue00 border-badgeBlue00',
  CANCELED: 'border-[0] text-bw06',
  ICON: 'relative',
};

export const STATUS_BADGE_LABELS = {
  PENDING: 'BILL_PAY.BILLS_HUB.STATUS_BADGES_TEXT.PENDING',
  PAID: 'BILL_PAY.BILLS_HUB.STATUS_BADGES_TEXT.PAID',
  CANCELED: 'BILL_PAY.BILLS_HUB.STATUS_BADGES_TEXT.CANCELED',
  AWAITING_DETAILS: 'BILL_PAY.BILLS_HUB.STATUS_BADGES_TEXT.AWAITING_DETAILS',
};
